import { render, staticRenderFns } from "./goodsRow.vue?vue&type=template&id=6ab5a6aa&scoped=true&"
import script from "./goodsRow.vue?vue&type=script&lang=js&"
export * from "./goodsRow.vue?vue&type=script&lang=js&"
import style0 from "./goodsRow.vue?vue&type=style&index=0&id=6ab5a6aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab5a6aa",
  null
  
)

export default component.exports